import { action, observable } from 'mobx';
import { ProductUploadForm } from 'application/product/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ProductService } from 'application/product/services';

@applicationContext
class ProductUploadViewStore extends BaseEditViewStore {
    @observable accessor errorMessage = null;
    constructor(rootStore) {
        const productService = new ProductService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'file',
            Form: ProductUploadForm,
            actions: () => {
                return {
                    create: async () => {
                        var file = this.form.fields.get("file").files[0];
                        var response = await productService.upload({ file: file });
                        if (response && response.customValues && response.customValues.updatedToDiscontinuedOnly) {
                            this.rootStore.notificationStore.warning(response.customValues.updatedToDiscontinuedOnly);
                        }
                    }
                }
            },
            FormClass: ProductUploadForm,
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            this.errorMessage = null;
            await setTimeout(() => this.rootStore.notificationStore.success('Products updated successfully.'), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            if (err && err.data && Array.isArray(err.data)) {
                this.errorMessage = err.data.join('\n\n');
                this.form.$("errorMessage").set(this.errorMessage);
            }
            else
            {
                this.errorMessage = null;
                this.rootStore.notificationStore.error(err && err.data && err.data.Message ? err.data.Message : (err && err.data ? err.data : 'Error occured while trying to update the products.'));
            }
        }
    }

    @action.bound
    async onInit({ initialLoad }) {
        if (!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default ProductUploadViewStore;
